import { taskToSize } from "../../nodes/mapper/layout";
import { getFlowTheme } from "../../theme";

import { BOTTOM_PORT_MARGIN } from "../../nodes/mapper/layout";

const TerminalTask = ({
  nodeData,
  portsVisible,
}: {
  nodeData: any;
  portsVisible?: boolean;
}) => {
  const mode = "light";
  const theme = getFlowTheme(mode);

  const { task } = nodeData;
  const terminalClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  let { width, height } = taskToSize(task);
  return (
    <div
      onClick={terminalClick}
      style={{
        width: width,
        height: height,
        marginTop:
          task.name === "start" && portsVisible ? -BOTTOM_PORT_MARGIN : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          width: width,
          // Not a mistake, we want the height to be the same as the width
          height: width,
          borderRadius: width,
          color: theme.terminalTask.color,
          background: theme.terminalTask.background,
          border: theme.terminalTask.border,
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {task.name === "start" ? "Start" : "End"}
      </div>
    </div>
  );
};

export default TerminalTask;
